import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { DataStateChangeEvent, GridDataResult } from '@progress/kendo-angular-grid';
import { State, orderBy, process } from '@progress/kendo-data-query';
import { TablerIconsModule } from 'angular-tabler-icons';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { CashDeskCoreRxDbService } from 'src/app/@clu-fe/apps/m-cashdesk/@services/m-cashdesk-core-rxdb.service';
import { KendoModule } from 'src/app/kendo.module';
import { MaterialModule } from 'src/app/material.module';
import { CustomDatePipe } from 'src/app/pipe/customDate.pipe';
import { CustomPipesModule } from 'src/app/pipe/customPipes.module';

@Component({
    selector     : 'md-clu-ghostmode-fn-rxdb-cashdesk',
    templateUrl  : './md-clu-ghostmode-fn-rxdb-cashdesk.component.html',
    styleUrls: ['./md-clu-ghostmode-fn-rxdb-cashdesk.component.scss'],
    standalone: true,
    encapsulation: ViewEncapsulation.None,
    imports: [FormsModule, MaterialModule, KendoModule, TranslateModule, TablerIconsModule, NgScrollbarModule, CustomPipesModule, CustomDatePipe],
    providers : [CashDeskCoreRxDbService]
})
export class MdCluGhostModeFnRxDbCashDeskComponent implements OnInit 
{
    private cluRxDbDataItems: unknown[];
    private dataItems: unknown[];
    public gridView: GridDataResult;
    public state: State = { skip: 0, take: 120, sort: [], };
    public height = window.innerHeight - 305;
    public loading: boolean;
    
    linkupCollection : any;
    linkupCollections : any[] = [];

    constructor(private _cashDeskRxDbService : CashDeskCoreRxDbService, private ref: ChangeDetectorRef, @Inject(MAT_DIALOG_DATA) private dataE: any, public matDialogRef: MatDialogRef<MdCluGhostModeFnRxDbCashDeskComponent>){
        this.doGridFetchAllData = this.doGridFetchAllData.bind(this);
    }

    async ngOnInit() {
        this.matDialogRef.keydownEvents().subscribe(event => { if (event.key === "Escape") { this.matDialogRef.close(); } });
        await this.doFormatLinkupCollections();
    }

    async doLoadRxDbDataItemsAction_CashDesk(_collectionName : string){
        if(_collectionName in this._cashDeskRxDbService.db) {
            this.loading = true;
            const RXDB_DATAITEMS = await (this._cashDeskRxDbService.db as any)[_collectionName].find().exec();
            this.loading = false;
            this.cluRxDbDataItems = JSON.parse(JSON.stringify(RXDB_DATAITEMS));
            this.dataItems = JSON.parse(JSON.stringify(RXDB_DATAITEMS));
            this.loadProducts();
        }
    }
    
    public onDataChange(state: DataStateChangeEvent): void {
        this.state = state;
        this.loadProducts();
    }

    public loadProducts(): void {
        this.gridView = process(this.dataItems, this.state);
    }
    
    @ViewChild('gridSearchInput') set gridSearchInput(element : ElementRef) {
        if(element){
            fromEvent(element.nativeElement, 'keyup')
            .pipe( debounceTime(250), distinctUntilChanged())  
            .subscribe(v=> this.onGridSearchInputChange(element.nativeElement.value));
        }
    };
    onGridSearchInputChange(inputValue: string): void {
        if(!this.linkupCollection) return;
        let _filters : any = [];
        if(this.linkupCollection && this.linkupCollection.columns) {
            for(let _column of this.linkupCollection.columns) {
                if(_column.pType === 'string') {
                    let _filter = {
                        field: _column.pName,
                        operator: "contains",
                        value: inputValue,
                    }
                    _filters.push(_filter);
                }
            }
        }
        this.dataItems = process(this.cluRxDbDataItems, {
            filter: {
              logic: "or",
              filters: _filters,
            },
        }).data;
        this.loadProducts();
    }

    doGridFetchAllData(): ExcelExportData {
        var _state : State = this.state;
        _state.skip = 0;
        _state.take = this.gridView.total;
        const result: ExcelExportData =  {
            data: process(this.dataItems, this.state).data
        };
        return result;
        /*const result: ExcelExportData =  {
            data: process(this.gridOptions.mData, { group: this.gridOptions.mGroups, sort: this.gridOptions.mSorts }).data,
            group: this.gridOptions.mGroups
        };
        return result;*/
    }
 
    private async doFormatLinkupCollections() {
        this.linkupCollections = [];
        if(!this._cashDeskRxDbService || !this._cashDeskRxDbService.db || !this._cashDeskRxDbService.db.collections) { return; }
        for (const [key, collection] of Object.entries(this._cashDeskRxDbService.db.collections)) {
            if(!collection.schema || !collection.schema.jsonSchema) { continue; }
            let linkupCollection : any = {
                name: key,
                lib : collection.schema.jsonSchema.title,
                collectionBrute: collection, 
                columns : []
            }
            let _properties = collection.schema.jsonSchema.properties;
            for(const [pKey, pValue] of Object.entries(_properties)) {
                if(pKey.startsWith('_')) { continue; }
                let _column : any = {
                    pName : pKey,
                    pType : (pValue.type ? pValue.type.toString() : 'string').replace(',null', ''),
                    hidden : false
                }
                if([''].indexOf(_column.pName) > - 1) { _column.hidden = true;}
                linkupCollection.columns.push(_column);
            }
            this.linkupCollections.push(linkupCollection);
        }
        this.linkupCollections = orderBy(this.linkupCollections, [{ field: 'name', dir: 'asc' }]);
        if(this.linkupCollections.length > 0){ await this.onLinkupCollectionPickedEvent(this.linkupCollections[0]); }
    }

    async onLinkupCollectionPickedEvent(_linkupCollection : any) {
        this.linkupCollection = _linkupCollection;
        await this.doLoadRxDbDataItemsAction_CashDesk(_linkupCollection.name);
    }

    async doExportRxDbAction_CashDesk(){
        let RXDB_OBJ : any = {};
        let _collections = this.linkupCollections;
        for(const _collection of _collections) {
            try { 
                const RXDB_DATAITEMS = await (this._cashDeskRxDbService.db as any)[_collection.name].find().exec();
                RXDB_OBJ[_collection.name] = JSON.parse(JSON.stringify(RXDB_DATAITEMS)); 
            } catch(error) {
                console.error('Error exporting collection:', _collection.name, error);
            }
        }
        const _rxDbObjectJson = JSON.stringify(RXDB_OBJ);
        const _bytes = new TextEncoder().encode(_rxDbObjectJson);
        const _blob = new Blob([_bytes], { type: "application/json;charset=utf-8" });
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        a.download = `RxDb_CashDesk.json`;
        a.href = URL.createObjectURL(_blob);
        a.target = '_blank';
        a.click();
        document.body.removeChild(a);

    }
}
